import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form as RForm, FormGroup, Label, Input, Button} from "reactstrap";
import { FaCircleNotch, FaDownload } from 'react-icons/fa';
import API from '../../../../Configs';
import Actions from '../../../../Actions';

class DownloadableReport extends Component {
    constructor(props){
        super(props);
        this.meta = API.REPORTS;
        this.reportType = this.meta[props.reportId];
        const [startDate] = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T');
        const [endDate] = new Date().toISOString().split('T');
        this.state = {
            startDate,
            endDate,
        };
    }

    getAgeFromDate = (dateString) => {
        const currentDate = new Date();
        const inputDate = new Date(dateString);
      
        const timeDifference = currentDate - inputDate;
        return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    }


    downloadReport = () => {
        const { getReports, auth, reportId } = this.props;
        const { startDate, endDate } = this.state;

        const ageTo = this.getAgeFromDate(startDate);
        const ageFrom = this.getAgeFromDate(endDate);
        getReports(auth.token, { sort: "total", order: "desc", ageFrom, ageTo }, reportId);
    }

    render(){
        const [currentDate] = new Date().toISOString().split('T');
        return (
            <RForm>
                <FormGroup>
                    <Label>
                        Start Date
                    </Label>
                    <Input 
                        type="date" 
                        onChange={e => {
                            e.persist();
                            this.setState({startDate: e.target.value, endDate: currentDate});
                        }} 
                        value={this.state.startDate}
                        max={currentDate}
                    />                           
                </FormGroup>
                
                <FormGroup >
                    <Label>
                        End Date
                    </Label>
                    <Input 
                        type="date" 
                        onChange={e => {
                            e.persist();
                            this.setState({endDate: e.target.value})
                        }}
                        value={this.state.endDate}
                        min={this.state.startDate}
                        max={currentDate}
                    />
                </FormGroup>
                <FormGroup>
                        <Button block disabled={this.props.reportsLoading} onClick={this.downloadReport} color="success" kind="squared">
                            {this.props.reportsLoading ? <FaCircleNotch className="icon-spin" style={{marginRight: '5px', verticalAlign:'text-bottom'}} /> : <FaDownload  style={{marginRight: '5px', verticalAlign:'text-bottom'}}/>}
                            Download
                        </Button>                           
                </FormGroup>
            </RForm>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    reportsLoading: state.reportStore.reportsLoading,
});

export default connect(mapStateToProps, Actions.reports)(DownloadableReport);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/DownloadableReport/index.js